export class TableSettingsEquals {
    public column: string = "";
    public value: string = "";

    constructor(columnP, valueP) {
        this.column = columnP;
        this.value = valueP;
    }
}